export default __webpack_public_path__ + "static/kb-4-91ec645dbbefae43c1d01f9eaebd2210.jpg";